const EMPTY_STRING = "";

$(document).ready(function () {
    var navigationCloseButton = $("nav .nav-close-button");
    navigationCloseButton.on("click", function (event) {
        event.preventDefault();
        var openedDropdown = $(".navbar-collapse.collapse.show");
        var bodyOverlayEl = $(".curtain");
        bodyOverlayEl.css("display", "none");
        openedDropdown.removeClass("show");
    });

    var navigationTogglerBtn = $(".navbar-toggler");
    navigationTogglerBtn.on("click", function () {
        var bodyOverlayEl = $(".curtain");
        bodyOverlayEl.css("display", "block");
    });

    var accountNavigation = $('.my-account-capitus');
    var responsiveNavigation = $('.visible-sm-only')[0];
    if (isElementResolved(accountNavigation) &&
        isElementResolved(responsiveNavigation)) {
        var accNavigationCopy = $(accountNavigation).clone();
        $(accNavigationCopy).removeClass().addClass('nav');
        $(accNavigationCopy).appendTo(responsiveNavigation);
    }

    var logoNavigationResponsive = $('.logo-xs');
    var smallImage = $('.small-logo');
    if (isElementResolved(logoNavigationResponsive) &&
        isElementResolved(smallImage)) {
        var smallImageCopy = $(smallImage).clone();
        $(smallImageCopy).appendTo(logoNavigationResponsive);
    }

    var responsiveModeBoxes = getResponsiveHeaderBoxes();

    responsiveModeBoxes.searchTogglerIcon.on("click", function () {
        openSearchResponsiveMode(responsiveModeBoxes);
    });

    responsiveModeBoxes.closeSearchIcon.on("click", function () {
        closeSearchResponsiveMode(responsiveModeBoxes);
    });

    var responsiveMenuDropdownsLinks = $('.dropdown');
    $(responsiveMenuDropdownsLinks).each(function (index) {
        var dropdown = $(this)[0];
        var dropdownLink = dropdown.firstElementChild;

        $(dropdownLink).on("click", function () {
            var arrowDown = $(this).find('.arrow-down');
            var arrowUp = $(this).find('.arrow-up');
            var dropdownClassList = $(dropdown).attr("class").split(/\s+/);
            var isDropdownCollapsed = false;
            var dropdownSiblings = getSiblings(dropdown);

            $(dropdownClassList).each(function (index) {
                if (dropdownClassList[index] == "show") {
                    isDropdownCollapsed = true;
                }
            });

            $(dropdownSiblings).each(function (index) {
                var sibDropdown = $(this)[0];
                var link = sibDropdown.firstElementChild;
                var aUp = $(link).find(".arrow-up");
                var aDown = $(link).find(".arrow-down");
                $(aUp).hide('fast');
                $(aDown).show('fast');
            });

            if (isDropdownCollapsed) {
                $(arrowDown).show('fast');
                $(arrowUp).hide('fast');
            } else {
                $(arrowDown).hide('fast');
                $(arrowUp).show('fast');
            }
        });
    });

    var employeeBioLinks = $('.read-bio');
    if (isElementResolved(employeeBioLinks) || employeeBioLinks.length !== 0) {
        $(employeeBioLinks).each(function () {
            var link = $(this);
            var overlayBioInfo = link.parents().next('.overlay-div');
            
            $(link).on("mouseover", function () {
                $(overlayBioInfo).show();
            });
            $(overlayBioInfo).on("mouseleave", function () {
                $(this).hide();
            })
        });
    }

    var aTables = $("table");
    $(aTables).each(function (index) {
        var table = this;
        var pastYearsTables = $(table).find(".past-year-body");
        if (pastYearsTables.length != 0 &&
            isElementResolved(pastYearsTables)) {

            $(pastYearsTables).each(function (index) {
                var pastYeartable = $(this);
                var tableRows = $(pastYeartable).children();
                var rowToggler = $(tableRows).find(".toggle-year");
                var winners = $(pastYeartable).children('.past-year-winners');

                $(rowToggler).on('click', function (event) {
                    event.preventDefault();
                    var self = this;

                    if (isElementDisplayed(winners)) {
                        $(self).removeClass("closed");
                        $(winners).show("fast");
                        
                        closeOpenedTableRows(pastYearsTables, self);
                        
                    } else {
                        $(self).addClass("closed");
                        $(winners).hide();
                    }
                });
            });
        }
    });
});

function getResponsiveHeaderBoxes() {
    var searchTogglerIcon = $("#search-toggle");
    var searchInputBox = $("#has-search");
    var searchColumn = $(".col-search")[0];
    var logoColumn = $(".col-logo")[0];
    var navTogglerColumn = $(".col-nav-toggler")[0];
    var navWrapperColumn = $(".nav-wrapper")[0];
    var closeSearchIcon = $("#close-search");
    var searchInput = $('.has-search input[type="search"]');

    return {
        searchTogglerIcon: searchTogglerIcon,
        searchInputBox: searchInputBox,
        searchColumn: searchColumn,
        logoColumn: logoColumn,
        navTogglerColumn: navTogglerColumn,
        navWrapperColumn: navWrapperColumn,
        closeSearchIcon: closeSearchIcon,
        searchInput: searchInput
    };
}

function openSearchResponsiveMode(responsiveElements) {
    hideHeaderElementsAboveMediumSize(responsiveElements.logoColumn,
        responsiveElements.navTogglerColumn,
        responsiveElements.searchTogglerIcon);

    expandSearchColumns(responsiveElements.searchColumn,
        responsiveElements.navWrapperColumn);

    showResponsiveSearchMenu(responsiveElements.searchInputBox,
        responsiveElements.searchInput,
        responsiveElements.closeSearchIcon);
}

function closeSearchResponsiveMode(responsiveElements) {
    showHeaderElementsAboveMediumSize(responsiveElements.logoColumn,
        responsiveElements.navTogglerColumn,
        responsiveElements.searchTogglerIcon);

    shrinkSearchColumns(responsiveElements.searchColumn,
        responsiveElements.navWrapperColumn);

    hideResponsiveSearchMenu(responsiveElements.searchInputBox,
        responsiveElements.searchInput,
        responsiveElements.closeSearchIcon);
}

function hideHeaderElementsAboveMediumSize(logoCol, navCol, searchToggleIcon) {
    $(logoCol).hide();
    $(navCol).hide();
    $(searchToggleIcon).hide();
}

function expandSearchColumns(searchColumn, navColumn) {
    var expandClass = "expand-col";
    $(searchColumn).addClass(expandClass);
    $(navColumn).addClass(expandClass);
}

function showResponsiveSearchMenu(searchWrapper, searchInput, closeButton) {
    $(searchWrapper).show("fast");
    $(searchInput)[0].focus();
    $(closeButton).show();
}

function showHeaderElementsAboveMediumSize(logoCol, navCol, searchToggleIcon) {
    $(logoCol).show("fast");
    $(navCol).show("fast");
    $(searchToggleIcon).show("fast");
}

function shrinkSearchColumns(searchColumn, navColumn) {
    var expandClass = "expand-col";
    $(searchColumn).removeClass(expandClass);
    $(navColumn).removeClass(expandClass);
}

function hideResponsiveSearchMenu(searchWrapper, searchInput, closeButton) {
    $(searchWrapper).hide();
    $(closeButton).hide();
    $(searchInput).val(function (i, val) {
        return EMPTY_STRING;
    });
}

function getSiblings(element) {
    var siblings = [];
    var sibling = element.parentNode.firstChild;
    while (sibling) {
        if (sibling.nodeType === 1 &&
            sibling !== element &&
            $(sibling).hasClass('dropdown')) {

            siblings.push(sibling);
        }
        sibling = sibling.nextSibling;
    }
    return siblings;
}

function isElementResolved(element) {
    return element !== "undefined" &&
        element !== undefined &&
        element !== null &&
        element !== "";
}

function isElementDisplayed(element) {
    return $(element).css('display') == "none";
}

function closeOpenedTableRows(tBodiesInTable, toggleElement) {
    for (var i = 0; i < tBodiesInTable.length; i++) {
        var rows = $(tBodiesInTable[i]).children();
        var toggler = $(rows).find(".toggle-year");
        var tableBody = tBodiesInTable[i];

        if (!$(toggler).hasClass('closed') &&
            !$(toggleElement).is($(toggler))) {

            $(tableBody).children(".past-year-winners").hide();
            $(toggler).addClass("closed");
        }
    }
}